var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
export var DATE_TIME_TIMEZONE = 'dateTimeTimezone';
export var TIME_TIMEZONE = 'timeTimezone';
export var DATE_TIME = 'dateTime';
export var DATE = 'date';
export var TIME = 'time';
/**
 * A simple function to determine if the event date exist and not blank.
 */
function dateNotPresent(date) {
    return isNaN(Date.parse(date));
}
/**
 * A wrapper function that checks whether date exists
 * and return translated date.
 */
function getTranslatedDate(date, translateDate, dateFormat) {
    var dateString = dateNotPresent(date) ? '' : translateDate(new Date(date), dateFormat || 'long');
    return dateString;
}
/**
 * A wrapper function that checks whether date exists
 * and return translated time.
 */
function getTranslatedTime(date, translateTime) {
    var timeString = dateNotPresent(date) ? '' : translateTime(new Date(date));
    return timeString;
}
/**
 * The basic date time range widget UI implementation.
 */
var DateTime = /** @class */ (function (_super) {
    __extends(DateTime, _super);
    function DateTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDateRange = function () {
            var _a = _this.props, translate = _a.translate, translateDate = _a.translateDate, dateFormat = _a.dateFormat;
            var startDate = getTranslatedDate(_this.props.startDate, translateDate, dateFormat);
            var endDate = getTranslatedDate(_this.props.endDate, translateDate, dateFormat);
            return !endDate || startDate === endDate ? startDate : translate('Widget_DateTimeWidget_DateRangeText__resx', {
                startDate: startDate,
                endDate: endDate
            });
        };
        _this.getTimeRange = function () {
            var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate, translateTime = _a.translateTime, translate = _a.translate;
            var startTime = getTranslatedTime(startDate, translateTime);
            var endTime = getTranslatedTime(endDate, translateTime);
            return !endTime ? startTime : translate('Widget_DateTimeWidget_TimeRangeText__resx', {
                startTime: startTime,
                endTime: endTime
            });
        };
        return _this;
    }
    DateTime.prototype.render = function () {
        var _a = this.props, timeZone = _a.timeZone, displayFormat = _a.displayFormat;
        var displayTime = displayFormat === DATE_TIME || displayFormat === DATE_TIME_TIMEZONE || displayFormat === TIME || displayFormat === TIME_TIMEZONE;
        var displayTimezone = displayFormat === DATE_TIME_TIMEZONE || displayFormat === TIME_TIMEZONE;
        var displayDate = displayFormat === DATE_TIME || displayFormat === DATE_TIME_TIMEZONE || displayFormat === DATE;
        return React.createElement("div", __assign({}, resolveTestId(this.props), resolve(this.props, 'container')),
            React.createElement("div", __assign({}, resolve(this.props, 'date')), displayDate && this.getDateRange()),
            React.createElement("div", __assign({}, resolve(this.props, 'timeTimeZone')),
                displayTime && this.getTimeRange(),
                displayTimezone && React.createElement("span", __assign({}, resolve(this.props, 'timeZone')), timeZone)));
    };
    DateTime.displayName = 'DateTimeComponent';
    DateTime.propTypes = {
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string,
        timeZone: PropTypes.string.isRequired,
        displayFormat: PropTypes.oneOf([DATE_TIME_TIMEZONE, DATE_TIME, DATE, TIME, TIME_TIMEZONE]),
        translate: PropTypes.func.isRequired,
        translateDate: PropTypes.func.isRequired,
        translateTime: PropTypes.func.isRequired,
        dateFormat: PropTypes.oneOfType([PropTypes.oneOf(['short', 'medium', 'long', 'full']), PropTypes.object])
    };
    return DateTime;
}(React.Component));
export default DateTime;
